/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleDownIcon16Regular = forwardRef('ArrowFigureACircleDownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 4.25a.75.75 0 0 1 .75.75v4.428L9.924 8.02a.75.75 0 1 1 1.152.96l-1.732 2.078c-.7.84-1.989.84-2.688 0L4.924 8.98a.75.75 0 0 1 1.152-.96L7.25 9.428V5A.75.75 0 0 1 8 4.25Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1Zm5.5 7a5.5 5.5 0 1 0-11 0 5.5 5.5 0 0 0 11 0Z" })));
});
